import React from 'react';

/**
 * Explanation text component for the word cloud
 */
const WordCloudExplanation = ({ firstName }) => {
    return (
        <>
            <p className="word-cloud-explanation-title">
                Adjectives selected by people who knew {firstName || 'them'} best
            </p>
            <p className="word-cloud-explanation">
                Larger, bolder words indicate they were selected by more people compared to smaller words.
            </p>
        </>
    );
};

export default WordCloudExplanation;
